export enum ConnectableConceptType {
    ELEMENT = "ELEMENT",
    RELATIONSHIP = "RELATIONSHIP",
}